<!-- Admin Single Article Edit -->

<template>
	<div class="adm-edit">

		<div class="banner wi8_font" v-html="convertLFs(curTitle)">
		</div>

		<div class="tab" ref="Pix" @click="clickTab('Pix')">
			<UniIcon ico="pic" fit="1" pad="5" color="#369" />
		</div>

		<div class="spacer" />

		<div class="tab" ref="Txt" @click="clickTab('Txt')">
			<UniIcon ico="write" fit="1" pad="5" color="#369" />
		</div>

		<div class="spacer" />

		<div class="tab" ref="Met" @click="clickTab('Met')">
			<UniIcon ico="gear" fit="1" pad="5" :color="(current.art.live=='1')? '#369': '#C30'" />
		</div>

		<div class="spacer" />

		<div class="tab" ref="Upd" @click="clickTab('Upd')">
			<UniIcon ico="check" fit="1" pad="5" color="#369" />
		</div>

		<div class="spacer" />

		<div class="content">
			<component :is="curCompName"/>
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { eventBus } from '@/main';
import { mapState } from 'vuex';
import AdmEditPix from '@/components/AdmEditPix';
import AdmEditTxt from '@/components/AdmEditTxt';
import AdmEditMet from '@/components/AdmEditMet';
import AdmEditUpd from '@/components/AdmEditUpd';

export default {
	data() {
		return {
			curCompName: "",
			curTitle: "Editing Article",
			titles: {
				Pix: 'Edit\nImages',
				Txt: 'Edit\nStory',
				Met: 'Edit\nMetadata',
				Upd: 'Ready to\nUpdate?',
			},
		}
	},
	computed: {
		...mapState('app', ['current']),
	},
	components: {
		AdmEditPix,
		AdmEditTxt,
		AdmEditMet,
		AdmEditUpd,
	},
	methods: {
		clickTab(tabName) {
			Object.keys(this.$refs).forEach(refName => {
				this.$refs[refName].className = "tab";
			});
			this.$refs[tabName].className = "tab active";
			this.curTitle = this.titles[tabName];
			this.curCompName = "AdmEdit" + tabName;
		},
		convertLFs(str1="") {
			let str2 = str1.replace(/\n/g, '<br/>', );
			return str2;
		},
	},
	created() {
		m("adm edit created");
		this.$store.dispatch('app/reqArtPix');
	},
	mounted() {
		m("adm edit mounted");
		this.clickTab('Pix');
	},
}
</script>

<style scoped>
.adm-edit {
	height: 100%;
	overflow: hidden;
	background-color: transparent;
	border: solid 0px #C30;
}

.banner {
	display: inline-block;
	width: calc(100% - 212px);
	height: 40px;
	overflow: hidden;		
	vertical-align: bottom;
	padding: 5px 0px 0px 10px;
	color: #369;
	font-size: 13px;
	line-height: 14px;
	border: solid 0px #999;
	border-bottom: solid 1px #999;
}

.tab {
	display: inline-block;
	width: 50px;
	height: 40px;
	overflow: hidden;
	vertical-align: bottom;
	cursor: pointer;
	background-color: #EEE;
	border: solid 1px #999;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
}

.active {
	background-color: #FFFCF6;
	border-bottom: solid 0px #999;
}

.spacer {
	display: inline-block;
	width: 3px;
	height: 10px;
	overflow: hidden;
	vertical-align: bottom;
	border: solid 0px #999;
	border-bottom: solid 1px #999;
}

.content {
	width: 100%;
	height: calc(100% - 40px);
	overflow: hidden;
	padding: 10px;
	background-color: #FFFCF6;
	border: solid 0px #369;

}

</style>
